import React from 'react';
import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { themeMode, variant, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const directionStyles = variant({
  prop: "direction",
  variants: {
    horizontal: {
      width: "100%",
      "&:before, &:after": {
        height: "1px"
      }
    },
    vertical: {
      height: "100%",
      flexDirection: "column",
      flexGrow: 1,
      "&:before, &:after": {
        width: "1px"
      }
    }
  }
});
const railStyles = css`
    content: ' ';
    flex-grow: 1;
    background-color: ${themeMode({ light: palette("neutral.200"), dark: palette("neutral.700") })};
`;
const StyledDivider = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${themeMode({ light: palette("neutral.500"), dark: palette("neutral.400") })};

    ${({ align }) => {
  switch (align) {
    case "center":
      return css`
                    &:after,
                    &:before {
                        ${railStyles}
                    }
                `;
    case "start":
      return css`
                    &:after {
                        ${railStyles}
                    }
                `;
    case "end":
      return css`
                    &:before {
                        ${railStyles}
                    }
                `;
    default:
      return css``;
  }
}}

    ${directionStyles};
`;
const Divider = (_a) => {
  var _b = _a, {
    children,
    direction = "horizontal",
    align = "center"
  } = _b, props = __objRest(_b, [
    "children",
    "direction",
    "align"
  ]);
  return /* @__PURE__ */ React.createElement(StyledDivider, {
    direction,
    align
  }, children && /* @__PURE__ */ React.createElement(Box, __spreadValues({
    pt: direction === "vertical" && align === "start" ? "none" : "md",
    pr: direction === "horizontal" && align === "end" ? "none" : "md",
    pb: direction === "vertical" && align === "end" ? "none" : "md",
    pl: direction === "horizontal" && align === "start" ? "none" : "md",
    role: "separator"
  }, props), children));
};
Divider.displayName = "Divider";

export { Divider };
//# sourceMappingURL=Divider.es.js.map
